import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createLegacyRedirectRoutes, createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { ERZ_PATHS_LEGACY, ERZ_ROUTES } from './config';

const WeaponTransportation = lazy(() => import('../pages/services/WeaponTransportation'));
const ResidenceRelocation = lazy(() => import('../pages/services/ResidenceRelocation'));
const TemporaryResidenceRelocation = lazy(() => import('../pages/services/TemporaryResidenceRelocation'));
const CommissionSales = lazy(() => import('../pages/services/CommissionSales'));
const PermissionRenewal = lazy(() => import('../pages/services/PermissionRenewal'));
const ColdSteelTransportation = lazy(() => import('../pages/services/ColdSteelTransportation'));
const WeaponPurchasePermit = lazy(() => import('../pages/services/WeaponPurchasePermit'));
const WeaponStorageCarrying = lazy(() => import('../pages/services/WeaponStorageCarrying'));
const ErzExtractPage = lazy(() => import('../pages/services/ErzExtract'));
const ColdSteelStorageForCollection = lazy(() => import('../pages/services/ColdSteelStorageForCollection'));
const CancellationTemporaryResidenceRelocation = lazy(
  () => import('../pages/services/CancellationTemporaryResidenceRelocation'),
);
const ERZSearch = lazy(() => import('../pages/services/ErzSearch'));
const WeaponRegistered = lazy(() => import('../pages/WeaponRegistered'));
const Reapplication = lazy(() => import('../pages/services/Reapplication'));

export const erzSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.ERZ>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION: CancellationTemporaryResidenceRelocation,
  COMMISSION_SALE: CommissionSales,
  ERZ_EXTRACT: ErzExtractPage,
  PURCHASE: WeaponPurchasePermit,
  STORAGE_CARRYING: WeaponStorageCarrying,
  TRANSPORT_ACROSS_BORDER: WeaponTransportation,
  VALIDITY_PERIOD_PROLONGATION: PermissionRenewal,
  COLD_STEEL_STORAGE_FOR_COLLECTION: ColdSteelStorageForCollection,
  RESIDENCE_RELOCATION: ResidenceRelocation,
  TEMPORARY_RESIDENCE_RELOCATION: TemporaryResidenceRelocation,
  COLD_STEEL_TRANSPORTATION: ColdSteelTransportation,
  ERZ_SEARCH: ERZSearch,
  WEAPON_REGISTERED: WeaponRegistered,
  REAPPLICATION: Reapplication,
};

export const ErzRoutes: RouteObject = createSystemRoutes(IntegrationSystem.ERZ, ERZ_ROUTES, erzSystemComponents);

export const ErzLegacyRoutes = createLegacyRedirectRoutes(ERZ_PATHS_LEGACY);
